import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import './Navbar.css';
import { useSelector } from 'react-redux';
import { isLoggedinUserAdminSelector } from '../store/slices/appSlice';

interface NavItem {
  name: string;
  href: string;
}

const staticNavigation: NavItem[] = [
  { name: 'Data Explorer', href: 'https://dataexplorer.worldforestid.org/' },
  { name: 'Verification', href: '/verification' },
  { name: 'Feedback Form', href: 'https://docs.google.com/forms/d/e/1FAIpQLSd2WqwIBiVBL44x_RhkxG_XkNa2HANXp0oeQaIA8Cs2h-RwuA/viewform' },
];

export default function Navbar() {
  const location = useLocation();
  const [navigation, setNavigation] = useState<NavItem[]>(staticNavigation);
  const isLoggedinUserAdmin = useSelector(isLoggedinUserAdminSelector);

  useEffect(() => {
    if (isLoggedinUserAdmin) {
      const updatedNavLinks = [
        { name: 'Determination', href: '/determination' },
        ...staticNavigation,
        { name: 'Test Viability', href: '/HsCode' },
        { name: 'Admin Manager', href: '/admin' },
      ];

      setNavigation(updatedNavLinks);
    }
  }, [isLoggedinUserAdmin]);

  return (
    <div className='Navbar'>
      <div className='flex flex-shrink-0 items-center'>
        <Link to='/'>
          <img
            className='main-logo'
            src='https://framerusercontent.com/images/Tt9qTMSWG5uNQmt7mgHHYgzTo.png'
            alt='Your Company'
          />
        </Link>
      </div>
      <div className='nav-links-container'>
        {location.pathname !== '/' &&
          navigation.map((item) => {
            if (item.name === 'Data Explorer') {
              return (
                <a href={item.href} target='_blank' rel='noreferrer'>
                  {item.name}
                </a>
              );
            }
            if (item.name === 'Feedback Form') {
              return (
                <a href={item.href} target='_blank' rel='noreferrer'>
                  {item.name}
                </a>
              );
            }
            return (
              <Link key={item.name} to={item.href} className={location.pathname.includes(item.href) ? 'active' : ''}>
                {item.name}
              </Link>
            );
          })}
      </div>
    </div>
  );
}
